/**
 * Kleri wordmark — lockup D, the single path from "Kleri Logo Charcoal RGB.svg".
 * Do not re-draw or re-trace it; the glyph is the brand asset.
 */
export const KLERI_PATH =
  "M287.843933,180.936035l96.182678,219.063965h-162.873352l-70.866638-182.149353v182.149353H0V0h150.286621v149.269348L217.145264,0h161.152039l-90.453369,180.936035ZM557.821289,0h-150.2854v400h263.430664v-129.118652h-113.145264V0ZM1403.80127,0v400h150.280029V0h-150.280029ZM850.52124,248.585327h106.82666v-99.427979h-106.853271v-37.141357h112.573303V0h-256.569336v400h262.862671v-112.016052h-118.840027v-39.398621ZM1304.174561,223.721313l78.400146,176.278687h-161.720215l-66.293213-171.791992v171.791992h-150.279968V0h203.426697c28.560059,0,53.906738,5.418701,76,16.283997,22.06665,10.837341,39.226562,25.711975,51.426514,44.563965,12.186768,18.881348,18.862061,40.104004,18.862061,63.726746,0,25.937317-7.355469,48.881226-20.875244,68.863892-7.893311,11.656006-17.546631,21.730713-28.946777,30.282715ZM1199.374512,130.501343c0-17.017334-14.053223-31.185364-31.466553-31.185364s-30.906738,14.16803-30.906738,31.185364c0,17.018677,13.493408,31.186646,30.906738,31.186646s31.466553-14.167969,31.466553-31.186646Z"

/** The K spans the full viewBox height, so the box height is also the cap height. */
export const KLERI_VIEWBOX = "0 0 1554.081299 400"

/** CSS `aspect-ratio` for placeholders and `<img>` swaps of the wordmark. */
export const KLERI_ASPECT = "1554.081299 / 400"

/**
 * Clearspace on every side = half the K height. The K spans the full viewBox
 * height, so in viewBox units that is `400 * KLERI_CLEARSPACE_RATIO` = 200.
 */
export const KLERI_CLEARSPACE_RATIO = 0.5

/** Brand minimum digital width for the wordmark. Never render it narrower. */
export const KLERI_MIN_WIDTH_PX = 75

export type KleriTone = "auto" | "charcoal" | "white" | "blue"

/**
 * The only three approved logo colours. `auto` inherits `currentColor` so the
 * mark follows the surrounding theme token instead of pinning a fourth hex.
 */
export const KLERI_TONES: Record<KleriTone, string | undefined> = {
  auto: undefined,
  blue: "#A6E7FF",
  charcoal: "#34393B",
  white: "#FFFFFF",
}
